import { render, staticRenderFns } from "./Submission.vue?vue&type=template&id=2df93adc&scoped=true"
import script from "./Submission.vue?vue&type=script&lang=js"
export * from "./Submission.vue?vue&type=script&lang=js"
import style0 from "./Submission.vue?vue&type=style&index=0&id=2df93adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df93adc",
  null
  
)

export default component.exports